import React, { ReactNode } from 'react';
import styled from 'styled-components';
import constants from '../../common/theme/constants';
import {
  KitFormFieldSet,
  KitFormGroup,
  KitFormInfoText,
  KitFormLabel,
  KitFormValue,
} from './KitFormControls';
import { KitFormInput } from './KitFormInput';
import { KitFormSelect } from './KitFormSelect';
import { KitFormTextArea } from './KitFormTextArea';

const Form = styled.form`
  & > div.kit-form-group,
  & > fieldset.kit-form-fieldset,
  & .kit-flex-col > div.kit-form-group,
  & .kit-flex-col > fieldset.kit-form-fieldset {
    margin-bottom: ${constants.spacing.absolute.l}px;
  }
  & > div.kit-form-group:last-child,
  & > fieldset.kit-form-fieldset:last-child,
  & .kit-flex-col:last-child > div.kit-form-group,
  & .kit-flex-col:last-child > fieldset.kit-form-fieldset {
    margin-bottom: 0;
  }
`;

interface KitFormProps extends React.ComponentPropsWithoutRef<'form'> {
  className?: string;
  children: ReactNode;
}

const KitForm: React.FC<KitFormProps> = ({ className, children, ...rest }) => {
  return (
    <Form className={className} {...rest}>
      {children}
    </Form>
  );
};

export default Object.assign(KitForm, {
  FieldSet: KitFormFieldSet,
  Group: KitFormGroup,
  Label: KitFormLabel,
  Value: KitFormValue,
  InfoText: KitFormInfoText,
  Input: KitFormInput,
  Select: KitFormSelect,
  TextArea: KitFormTextArea,
});
